import { configureStore } from "@reduxjs/toolkit";
import userFeedSlice from "./modules/userFeedSlice";
import dashboardSlice from "./modules/dashboard";
import postSlice from "./modules/postSlice";
import homeSlice from "./modules/home";
import userSlice from "./modules/user";
import marketSlice from "./modules/market";
import logger from "redux-logger";
import thunk from "redux-thunk";

import { createBrowserHistory } from "history";

export const history = createBrowserHistory();

const middlewares = [thunk.withExtraArgument({ history })];
if (process.env.NODE_ENV === "development") middlewares.push(logger);

const store = configureStore({
  reducer: {
    dashboard: dashboardSlice,
    post: postSlice,
    home: homeSlice,
    user: userSlice,
    myPage: userFeedSlice,
    market: marketSlice,
  },
  middleware: [...middlewares],
  devTools: process.env.NODE_ENV !== "production",
});

export default store;
